export default String.raw`

`